<template>
  <div class="pa-16 pt-0">
    <ValidationObserver ref="form">
      <WsBreadCrumbs :items="breadcrumbsItems"> </WsBreadCrumbs>
      <WsTitle>{{title}}</WsTitle>
      <div v-if="isLoading">
        <v-skeleton-loader
          v-for="n in 3"
          :key="`skeleton-${n}`"
          type="list-item-three-line"
          :tile="true"
          class="mt-5"
        ></v-skeleton-loader>
      </div>
      <WsUpdateMultiLayerLayers
        :value="layers"
        :fields="layersSetting.fields"
        @input="$_onStateInput($event)"
        @delete="$_onStateDelete($event)"        
      ></WsUpdateMultiLayerLayers>
    </ValidationObserver>
    <WsMainBottomNav>
      <WsBtn
        color="textSecondary"
        outlined
        @click="$router.go(-1)"
      >取消</WsBtn>
      <WsBtn @click="$_onSubmit()">送出</WsBtn>
    </WsMainBottomNav>
  </div>
</template>

<script>
import S_multiLayer from "@/helpers/multiLayer";
export default {
  data: () => ({
    isLoading: false,
    layers: [],
    updateData: [],
    deleteData: [],
    breadcrumbsItems: []
  }),
  methods: {
    async $_fetchData() {
      try {
        this.isLoading = true
        const url = `${this.modelName}/${this.$route.params.id}`
        const res = await this.$axios.get(url)
        this.breadcrumbsItems = this.$_setBreadcrumbsItems(res.data.data)
        this.layers = this.$_setItems(res.data.data)
        this.isLoading = false
      } catch (error) {
        alert(error)
      }
    },
    $_setItems(data) {
      const keys = {
        valueKey: this.valueKey,
        textKey: this.textKey,
        setLayersKey: 'layers',
      }
      if (this.layersSetting) {
        keys.getLayersKey = this.layersSetting.getLayersKey
        if (this.layersSetting.fieldKeys) {
          keys.fieldKeys = this.layersSetting.fieldKeys
        }
      } else {
        keys.getLayersKey = this.modelName
      }
      const layers = S_multiLayer.setItems(data, keys, true)
      return layers
    },
    $_onStateInput($event) {
      this.layers = $event.fullValue
      if (
        $event.updateValue[`${this.valueKey}`] !== undefined 
        && $event.updateValue[`${this.valueKey}`] !== null
      ) {
        const targetIndex = this.updateData.findIndex((e) => e[`${this.valueKey}`] === $event.updateValue[`${this.valueKey}`])
        if (targetIndex >= 0) {
          this.updateData.splice(targetIndex, 1, $event.updateValue)
        } else {
          this.updateData.push($event.updateValue)
        }
      }
    },
    $_onStateDelete($event) {
      this.layers = $event.fullValue
      this.deleteData.push($event.deleteValue[`${this.valueKey}`])
    },
    async $_onSubmit() {
      try {
        this.isLoading = true
        if (this.updateData.length > 0) {
          const task = []
          this.updateData.forEach((_updateData) => {
            let url = ''
            if (this.getUrl) {
              url = this.getUrl("update", _updateData)
            } else {
              url = `${this.modelName}/${_updateData[`${this.valueKey}`]}`
            }
            const payload = this.getPayload("update", _updateData)
            task.push(this.$axios.put(url, payload))
          })
          await Promise.all(task)
        }
        if (this.deleteData.length > 0) {
          const task = []
          this.deleteData.forEach((_deleteData) => {
            let url = ''
            if (this.getUrl) {
              url = this.getUrl('delete', _deleteData)
            } else {
              url = `${this.modelName}/${_deleteData}`
            }
            task.push(this.$axios.delete(url))
          })
          await Promise.all(task)
        }
        await this.$_onCreate(this.layers)
        if (this.sortable) {
          await this.$_onSort()
        }
        this.$router.go(-1)
        this.isLoading = false
      } catch (error) {
        alert(error)
      }
    },
    async $_onCreate(layers) {
      for (let layer of layers) {
        if (layer[`${this.valueKey}`] === null) {
          try {
            let url = ''
            if (this.getUrl) {
              url = this.getUrl("create")
            } else {
              url = `${this.modelName}`
            }
            const payload = this.getPayload("create", layer)
            const res = await this.$axios.post(url, payload)
            layer[`${this.valueKey}`] = res.data.data[`${this.valueKey}`]
            if (layer.layers && layer.layers.length > 0) {
              layer.layers.forEach((_layer) => {
                _layer[`parent_${this.valueKey}`] = res.data.data[`${this.valueKey}`]
              })
              await this.$_onCreate(layer.layers)
            }
          } catch (error) {
            alert(error)
          }
        } else {
          if (layer.layers && layer.layers.length > 0) {
            await this.$_onCreate(layer.layers)
          }
        }
      }
    },
    $_setBreadcrumbsItems(data) {
      const _breadcrumbsItems = [];
      _breadcrumbsItems.push({
        text: this.label,
        to: `/${this.modelName}`,
        disabled: false,
      });
      _breadcrumbsItems.push({
        text: data[`${this.textKey}`],
        to: `/${this.modelName}/${this.$route.params.id}`,
        disabled: false,
      });
      _breadcrumbsItems.push({
        text: this.title,
        disabled: true,
      });
      return _breadcrumbsItems;
    },
    async $_onSort() {
      try {
        let url = ''
        if (this.getUrl) {
          url = this.getUrl("sort")
        } else {
          url = `${this.modelName}_sequence`
        }
        const payload = this.getPayload("sort", this.layers)
        await this.$axios.patch(url, payload)
      } catch (error) {
        alert(error)
      }
    },
  },
  async mounted() {
    await this.$_fetchData()
  },
  props: {
    modelName: {
      type: String,
    },
    layersSetting: {
      type: Object,
    },
    title: {
      type: String,
    },
    label: {
      type: String,
    },
    textKey: {
      type: String,
      default: 'name',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    sortable: {
      type: Boolean,
      default: true
    },
    getUrl: {
      type: Function,
    },
    getPayload: {
      type: Function,
    },
  },
};
</script>